import { createContext, useContext } from "react";
import Article, { ArticeTranslationKeys, ArticleTranslations, ItemTranslations } from "../models/menu/Article";
import md5 from "md5";
import { selectAppLanguage } from "../../../kiosk/components/LanguageSelector/useLanguage";
import { useAppSelector } from "../redux/store.tsx";
import { Language } from "../../../types/shared/language.ts";
import OptionGroup from "../models/menu/OptionGroup.ts";

export enum OptionTranslationType {
  OptionGroup = "mainOption",
  Option = "option",
}

function translateOption(
  originalName: string,
  language: Language,
  optionType: OptionTranslationType,
  translations?: ArticleTranslations
): string {
  if (translations) {
    const t = translations[language];
    if (t) {
      const titleMd5 = md5(`${optionType}${originalName}`);
      if (titleMd5 in t) {
        return t[titleMd5] ?? "";
      }
    }
  }

  if (translations?.[language]?.name) {
    return translations?.[language].name;
  }

  return originalName;
}

export const TranslationsContext = <T>() => createContext<ItemTranslations<T> | undefined>({});
export const ArticleTranslationsContext = TranslationsContext<Article["translations"]>();
export const PackagingTranslationsContext = TranslationsContext<"name">();
export const OptionGroupTranslationsContext = TranslationsContext<OptionGroup["translations"]>();
export const useOptionTranslations = () => {
  const translations = useContext(TranslationsContext<ArticeTranslationKeys>());
  const selectedLanguage = useAppSelector(selectAppLanguage);

  return {
    translate: (originalName: string, optionType: OptionTranslationType = OptionTranslationType.Option) => {
      return translateOption(originalName, selectedLanguage, optionType, translations);
    },
  };
};
